module.exports = __webpack_public_path__ + "img/h-page4-63.1adc536c.png";